// Master JS for Potluck view
// Assumes existence of global variable window.CurrentTrain

import BootstrapModal from "bootstrap/js/dist/modal";
import { Router } from "./lib/router.js";

import { PostJSON } from "./lib/fetchers.js";
import { WireupHandlers } from "./lib/data-wireup.js";
import { WidthObserver } from "./lib/width-observer.js";
import { TrackClick } from "./lib/click-tracking.js";
import { ShowParticipantsModal } from "./lib/participants-modal.js";

import { ShareOptions } from "./webcomponents/share-options.js";
import { ProgressBar } from "./webcomponents/progress-bar.js";
import { FacePile } from "./webcomponents/face-pile.js";
import { PotluckRow } from "./webcomponents/potluck-row.js";

// Register required webcomponents
ShareOptions.Register();
ProgressBar.Register();
FacePile.Register();
PotluckRow.Register();

// Activate the resizeObserver
WidthObserver.PerformWireup();

////// PARTICIPANTS MODAL

// Wire up the "View all" button
WireupHandlers("showparticipants", "click", () => ShowParticipantsModal("modalTrainParticipants"));

////// SUPPORT FOR: /trains/{id}/share url

async function ShowShareModal() {
    const modalElement = document.getElementById("modalTrainShare");
    const modal = BootstrapModal.getOrCreateInstance(modalElement);
    modal.show();

    // Let other code know the user has already been shown a modal
    window.ShownAModal = true;
}

////// CLIENT SIDE ROUTING

Router.Base(window.CurrentTrain.OpenUrl);
Router.Add("/share", ShowShareModal);
Router.HandleCurrentUrl();
const modalShare = document.getElementById("modalTrainShare");
if (modalShare) modalShare.addEventListener("hide.bs.modal", () => { Router.RewriteUrl("/"); });

////// LOCAL STORAGE OF RECENT EVENTS

async function SaveToRecentList() {
    if (typeof (Storage) !== "undefined") {
        try {
            const result = await PostJSON("/trains/recent/", { source: localStorage.getItem("recent"), append: window.CurrentTrain.Id });
            if (result.ok) {
                localStorage.setItem("recent", result.obj);
            }
        } catch {
            // OK to ignore
        }
    }
}
window.addEventListener("DOMContentLoaded", async () => {
    SaveToRecentList();
});

////// CLICK TRACKING
WireupHandlers("click-tracking", "click", e => TrackClick(e.currentTarget));